.Avatar {
  display: inline-block;
  overflow: hidden;
  width: var(--base-size-40);
  height: var(--base-size-40);
}

.Avatar--shape-circle {
  border-radius: var(--brand-borderRadius-full);
}

.Avatar--shape-square {
  border-radius: var(--brand-borderRadius-medium);
}

.Avatar__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Avatar--size-32 {
  width: var(--base-size-32);
  height: var(--base-size-32);
}

.Avatar--size-40 {
  width: var(--base-size-40);
  height: var(--base-size-40);
}

.Avatar--size-48 {
  width: var(--base-size-48);
  height: var(--base-size-48);
}

.Avatar--size-64 {
  width: var(--base-size-64);
  height: var(--base-size-64);
}

.Avatar--size-80 {
  width: var(--base-size-80);
  height: var(--base-size-80);
}

.Avatar-narrow--size-32 {
  width: var(--base-size-32);
  height: var(--base-size-32);
}

.Avatar-narrow--size-40 {
  width: var(--base-size-40);
  height: var(--base-size-40);
}

.Avatar-narrow--size-48 {
  width: var(--base-size-48);
  height: var(--base-size-48);
}

@media screen and (min-width: 48rem) {
  .Avatar-regular--size-32 {
    width: var(--base-size-32);
    height: var(--base-size-32);
  }

  .Avatar-regular--size-40 {
    width: var(--base-size-40);
    height: var(--base-size-40);
  }

  .Avatar-regular--size-48 {
    width: var(--base-size-48);
    height: var(--base-size-48);
  }

  .Avatar-regular--size-64 {
    width: var(--base-size-64);
    height: var(--base-size-64);
  }

  .Avatar-regular--size-80 {
    width: var(--base-size-80);
    height: var(--base-size-80);
  }
}

@media screen and (min-width: 80rem) {
  .Avatar-wide--size-32 {
    width: var(--base-size-32);
    height: var(--base-size-32);
  }

  .Avatar-wide--size-40 {
    width: var(--base-size-40);
    height: var(--base-size-40);
  }

  .Avatar-wide--size-48 {
    width: var(--base-size-48);
    height: var(--base-size-48);
  }

  .Avatar-wide--size-64 {
    width: var(--base-size-64);
    height: var(--base-size-64);
  }

  .Avatar-wide--size-80 {
    width: var(--base-size-80);
    height: var(--base-size-80);
  }
}
